<kt-drp-dashboard-body [patient]="patient"></kt-drp-dashboard-body>
